import { branding } from '@/shared/config/branding'
import { platform } from '@/shared/lib/platform/platform'

/** Cor de fundo do splash nativo — alinhada a capacitor.config.ts e scripts/brand-asset-paths.mjs. */
export const SPLASH_BACKGROUND_COLOR = branding.splashBackgroundColor

/** Recurso drawable Android gerado por scripts/generate-icons.mjs. */
export const NATIVE_SPLASH_RESOURCE_NAME = 'splash'

/** Oculta splash nativa após primeira pintura (no-op na web). */
export const hideSplashScreen = async (): Promise<void> => {
  if (!platform.isNative()) {
    return
  }
  const { SplashScreen } = await import('@capacitor/splash-screen')
  await SplashScreen.hide()
}

/** Exibe splash nativa (no-op na web). */
export const showSplashScreen = async (): Promise<void> => {
  if (!platform.isNative()) {
    return
  }
  const { SplashScreen } = await import('@capacitor/splash-screen')
  await SplashScreen.show()
}
